import React from 'react'
import { theme } from '../../../muiTheme'
import { Pagination as MuiPagination, ThemeProvider } from '@mui/material'

const Pagination = ({ page, pageSize, totalRecords, onChange }) => {
  return (
    <ThemeProvider theme={theme}>
      <MuiPagination
        page={page}
        count={Math.ceil(totalRecords / pageSize)}
        onChange={(_, page) => onChange(page)}
        size="large"
      />
    </ThemeProvider>
  )
}

export default Pagination
